export default "__VITE_ASSET__IfJM78TJ__"